import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import { useEffect } from 'react'

// Style
import './style.scss'

import { useParams } from 'react-router-dom'
import { Element } from 'react-scroll'
import { useActionCreators, useAppSelector, useSwitcher } from 'shared/hooks'

// Actions
import { campaign } from '../../../actions/campaign'
import { campaignCreateActions } from '../../../redux/reducers/campaignCreate'
import exclaim from './../../../assets/image/icons/svg/exclaim-black.svg'
// Components
import ContainerStep from './step'

// const getStatus = (info) => info.find((item) => item.id === 1).value;

// TODO: remove necro code, replace loading for parent FC

export function CampaignSteps({
	onNotFound
}: {
	onNotFound(): void
}) {
	const loaderSwitcher = useSwitcher(true)

	const errorSwitcher = useSwitcher(false)

	const { id } = useParams<{ id: string }>()

	const name = useAppSelector(state => state.campaign.name)
	const allowAddSteps = useAppSelector(state => state.campaign.allowAddSteps)

	useSyncFinishStep()

	// biome-ignore lint/correctness/useExhaustiveDependencies: setters is memoized
	useEffect(() => {
		loaderSwitcher.on()
		errorSwitcher.off()

		campaign
			.getCampaignId(id)
			.catch(e => {
				console.error(e)
				errorSwitcher.on()
			})
			.then(res => {
				if (!res) {
					onNotFound()
				}
			})
			.finally(() => {
				loaderSwitcher.off()
			})
	}, [id, onNotFound])

	if (loaderSwitcher.isOn) {
		return <FullLoader size={60} />
	}

	return (
		<div className='steps-template'>
			<div className='flex-container-arrow'>
				{/* <div className='edit-title-text'>
					<p>{labelName}</p>
				</div> */}
				<Element
					className='steps-template-header'
					name='myScrollToElement-zoomed-message'
				>
					<h3>{name}</h3>
				</Element>
			</div>

			{!allowAddSteps && !errorSwitcher.isOn && (
				<div className='edit-notification'>
					<img
						alt='exclaim'
						className='edit-notification__icon'
						src={exclaim}
					/>
					<p className='edit-notification__text'>
						The campaign has already started, editing is limited
					</p>
				</div>
			)}

			{!errorSwitcher.isOn && <ContainerStep />}
		</div>
	)
}

function useSyncFinishStep() {
	const count = useAppSelector(state => state.campaign.count)
	const { setFinishStep } = useActionCreators(campaignCreateActions)

	useEffect(() => {
		setFinishStep(count > 0 ? '1' : '2')
	}, [count, setFinishStep])
}
